import max from "lodash/max";
import min from "lodash/min";

const mathFn = {
  max: (set) => max(set),
  min: (set) => min(set)
};

export default mathFn;
